import { DATA_TABLE_SIZE, type DataTableSize } from './types';

const DATA_TABLE_CELL_CLASSES = 'text-14 text-left text-midnight whitespace-nowrap overflow-hidden text-ellipsis';

type DataTableSizeClassNames = {
    cell: string;
    header: string;
};

export const DATA_TABLE_SIZE_CLASSES: Record<DataTableSize, DataTableSizeClassNames> = {
    [DATA_TABLE_SIZE.DEFAULT]: {
        cell: `p-4 ${DATA_TABLE_CELL_CLASSES}`,
        header: 'h-12 px-4',
    },
    [DATA_TABLE_SIZE.SM]: {
        cell: `px-3 py-1.5 ${DATA_TABLE_CELL_CLASSES}`,
        header: 'h-8 px-3',
    },
};
